import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackPhoneNumberVisibleEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackPhoneNumberVisible = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackPhoneNumberVisibleEventData => {
  const eventData: LegacyTrackPhoneNumberVisibleEventData = {
    eventType: 'conversion',
    conversionType: 'phonenumber-visible',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
    information: {
      context: 'card',
    },
  };

  return eventData;
};

export const useLegacyTrackPhoneNumberVisible = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyPhoneNumberVisible = useCallback(
    (vehicle: ElasticVehicle) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'conversion',
        data: createLegacyTrackPhoneNumberVisible(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyPhoneNumberVisible,
  };
};
